import createCollapsibleFieldset, { defaultTitle } from './CollapsibleFieldset.component';

export { defaultTitle };
export default createCollapsibleFieldset;
